export default () => {
    if (process.server) {
        return;
    }

            const polyfill = require("matchmedia-polyfill");
}